import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { FlexContainer } from '@pitchero/react-ui';
import CompetitionRoundup from './competition-roundup';
import HeadToHead from './head-to-head';
import FormGuidePlayerStats from './form-guide-player-stats';
import MatchLocation from './location';
import MatchPreview from './preview';
import MatchVideos from './videos';

const MatchOverview = ({
  competitionRoundup,
  headToHead,
  location,
  overview,
  playerStats,
  preview,
  shareProps,
  videos,
  teamId,
}) => {
  const hasNoContent =
    isEmpty(videos) &&
    isEmpty(competitionRoundup) &&
    isEmpty(headToHead) &&
    isEmpty(location) &&
    isEmpty(playerStats) &&
    isEmpty(preview);

  if (hasNoContent) {
    // Puts out a place holder match preview
    return <MatchPreview />;
  }

  return (
    <FlexContainer flexDirection="column" style={{ gap: '20px', paddingBottom: '20px' }}>
      {videos.length > 0 && <MatchVideos videos={videos} />}
      {preview && <MatchPreview {...preview} shareProps={shareProps} />}
      {location && <MatchLocation location={location} homeTeam={overview.home} />}
      {competitionRoundup && competitionRoundup.length > 0 && (
        <CompetitionRoundup fixtures={competitionRoundup} competitionName={overview.competition} />
      )}
      {headToHead && headToHead.length > 0 && <HeadToHead fixtures={headToHead} />}
      {playerStats && playerStats.length > 0 && (
        <FormGuidePlayerStats stats={playerStats} overview={overview} teamId={teamId} />
      )}
    </FlexContainer>
  );
};

MatchOverview.defaultProps = {
  competitionRoundup: [],
  headToHead: [],
  location: null,
  overview: null,
  playerStats: [],
  preview: null,
  shareProps: null,
  videos: [],
};

MatchOverview.propTypes = {
  competitionRoundup: PropTypes.arrayOf(PropTypes.shape()),
  location: PropTypes.shape(),
  overview: PropTypes.shape({
    home: PropTypes.shape().isRequired,
    competition: PropTypes.string,
  }),
  headToHead: PropTypes.arrayOf(PropTypes.shape()),
  playerStats: PropTypes.arrayOf(PropTypes.shape()),
  preview: PropTypes.shape(),
  shareProps: PropTypes.shape(),
  teamId: PropTypes.number.isRequired,
  videos: PropTypes.arrayOf(PropTypes.shape()),
};

export default MatchOverview;
